import { Badge } from "@/design-system/components/ui";
import { DEAL_TYPE_LABEL, type DealType } from "@/types/deals";

/**
 * Owner Recapitalization Loan (surface U3, OP15) — the gold "Owner
 * Recapitalization" badge on the deal header, the Kanban card and the
 * embedded deal lists. Acquisition, the default, shows no badge; a list that
 * must name every type uses a column instead (the Pipeline table).
 */
export function DealTypeBadge({ dealType }: { dealType?: DealType | null }) {
  if (dealType !== "OwnerRecapitalization") return null;
  return <Badge status="gold">{DEAL_TYPE_LABEL.OwnerRecapitalization}</Badge>;
}
